/*jshint esversion: 6 */
import React, { Component } from 'react';

export default function DisplayManus(props){
    return(
        DisplayManus_File(props)
        //(props.more)?  
            //DisplayManusMoreList(props) ;//:  
            //DisplayManusLessList(props)
    );
}
export function DisplayManus_File(props){
    const templateheader = props.templateheader;
    const extLinkUrl = props.linkstoURl;
    console.log('extLinkUrl', extLinkUrl);
    const nextSplit = 'v=';
    let srcFile = props.file;
    let youtubeId = '';
    let youtubeEmbedUrl = 'https://www.youtube.com/embed/';
    if(srcFile.toLowerCase().indexOf('https://www.youtube.com') > -1){
        let youtubeIdArr = srcFile.split('/');
        if(youtubeIdArr){
            if(youtubeIdArr.length){
                youtubeId = youtubeIdArr[youtubeIdArr.length-1];
                if(youtubeId.indexOf(nextSplit) > -1){
                    let youtubeIdArr2 = srcFile.split(nextSplit);
                    if(youtubeIdArr2){
                        if(youtubeIdArr2.length){
                            let youtubeId2 = youtubeIdArr2[youtubeIdArr2.length-1];
                            youtubeEmbedUrl += youtubeId2;
                        }
                    }
                }
                else{
                    youtubeEmbedUrl += youtubeId;
                }
            }
        }
    }

    return(
        <div className="column file_column">
            <div className="imgContainerCell">
                    { (youtubeId) ?
                        <iframe className="filesTableImg embed_youtube"
                            src =  {youtubeEmbedUrl}>
                        </iframe>
                        :
                        <a href ={extLinkUrl} target="_blank">
                            <img className={"filesTableImg " + " image_" + templateheader}
                                src ={props.file}
                                alt={props.originalname} />
                        </a>
                    }
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/utils/displayManusFile.js